import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from 'redux-store';

import type { SpecialOfferPageInitialState } from './payments.interfaces';

const initialState: SpecialOfferPageInitialState = {
  isTimerVisible: false,
  start: '',
};

export const specialOfferPageSlice = createSlice({
  name: 'specialOfferPage',
  initialState,
  reducers: {
    showTimer(state, { payload }: PayloadAction<{ start: string }>) {
      state.isTimerVisible = true;
      state.start = payload.start;
    },
    hideTimer(state) {
      state.isTimerVisible = false;
      state.start = '';
    },
  },
  extraReducers: builder => {
    builder.addCase(
      HYDRATE,
      (state, { payload }: HydrateAction<SpecialOfferPageInitialState>) => {
        return payload.specialOfferPage;
      },
    );
  },
});

export const { actions, reducer } = specialOfferPageSlice;
